import * as React from 'react';
var PlayIcon = function () { return (React.createElement("svg", { width: "18px", height: "20px", viewBox: "0 0 18 20", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { fill: "currentcolor" },
        React.createElement("path", { d: "M17.29,9.02 C18.25,9.56 18.25,10.44 17.29,10.98 L1.74,19.78 C0.78,20.33 0,19.87 0,18.76 L0,1.24 C0,0.13 0.78,-0.32 1.74,0.22 L17.29,9.02 Z" })))); };
export default PlayIcon;
//# sourceMappingURL=play.js.map